var initGorgiasChatPromise = (window.GorgiasChat) ? window.GorgiasChat.init() : new Promise(function (resolve) { window.addEventListener('gorgias-widget-loaded', function () { resolve();})});

initGorgiasChatPromise.then(function() {
    GorgiasChat.on('widget:closed', function(data) {
      var chatButtonIframe = document.querySelector('#chat-button'); 
      chatButtonIframe.style = "display:none;" 
    })
});



document.addEventListener('DOMContentLoaded', function() {
  var timer = setInterval(function () {
    var chatButtonHead = document.querySelector('#gorgias-chat-container')?.querySelector('#chat-button')?.contentWindow.document.querySelector('head'); 
    if (!chatButtonHead?.children.length) { 
      return; 
    } 
    clearInterval(timer); 
    var chatButtonIframe = document.querySelector('#chat-button'); 
    chatButtonIframe.style = "display:none;" 

    const wrapper = document.querySelector('.mobile-sticky-bar__wrapper');
    const link = wrapper.querySelector('a[href="#"]');

    link.addEventListener('click', function(event) {
      event.preventDefault();
      console.log('mobile link clicked');
      if (GorgiasChat.isOpen()) { 
        GorgiasChat.close(); 
      } else { 
        GorgiasChat.open(); 
      } 
    });

    const supportLink = document.querySelector('a[title="getpop-gorgias-chat"]');

    supportLink.addEventListener("click", function(event) {
      event.preventDefault(); // Prevent default behavior
      console.log('desktop link clicked');
      if (GorgiasChat.isOpen()) { 
        GorgiasChat.on('widget:close', function() {
          console.log('widget:close');
        });
        GorgiasChat.close(); 
        var chatButtonIframe = document.querySelector('#chat-button'); 
        chatButtonIframe.style = "display:none;" 
      } else { 
        GorgiasChat.open(); 
        var chatButtonIframe = document.querySelector('#chat-button'); 
        chatButtonIframe.style = "display:block;" 
      } 
    });

  }, 50);
});